export const DEFAULT_ENGINE_OPTIONS = {
    adaptToDeviceRatio: true,
    antialias: true,
    disableWebGL2Support: false,
    disableVertexArrayObjects: false,
    disableInstancing: false,
};
function isFlagSet(params, name) {
    const value = params.get(name);
    if (value === null)
        return false;
    return value !== '0' && value.toLowerCase() !== 'false';
}
export function engineOptionsFromQuery(search) {
    const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
    return {
        adaptToDeviceRatio: !isFlagSet(params, 'nodpr'),
        antialias: !isFlagSet(params, 'noaa'),
        disableWebGL2Support: isFlagSet(params, 'webgl1'),
        disableVertexArrayObjects: isFlagSet(params, 'novao'),
        disableInstancing: isFlagSet(params, 'noinst'),
    };
}
/** Human-readable summary of any overrides in force, for logging on startup. */
export function describeEngineOptions(options) {
    const overrides = [];
    if (options.disableWebGL2Support)
        overrides.push('WebGL 1 forced');
    if (!options.antialias)
        overrides.push('antialiasing off');
    if (!options.adaptToDeviceRatio)
        overrides.push('device pixel ratio ignored');
    if (options.disableVertexArrayObjects)
        overrides.push('vertex array objects off');
    if (options.disableInstancing)
        overrides.push('hardware instancing off');
    return overrides.length ? overrides.join(', ') : 'defaults';
}
